// Modal Component
// Handles modals (seller name, preferential confirmation)

import { setUserDocument } from '../services/firestore-service.js';
import stateManager from '../core/state-manager.js';

/**
 * Initialize seller name modal
 * Shows when seller has no name set
 *
 * @param {object} sellerInfo - Seller information
 */
export function showSellerNameModal(sellerInfo) {
    const modal = document.getElementById('name-modal');

    if (!sellerInfo || !sellerInfo.name) {
        modal.classList.remove('hidden');
    } else {
        modal.classList.add('hidden');
    }
}

/**
 * Initialize seller name modal handlers
 */
export function initSellerNameModal() {
    const saveButton = document.getElementById('save-seller-name');
    const nameInput = document.getElementById('seller-name-input');

    saveButton.addEventListener('click', async () => {
        const name = nameInput.value.trim();
        const currentUser = stateManager.getState('currentUser');

        if (name && currentUser) {
            await setUserDocument(currentUser.uid, {
                name: name,
                email: currentUser.email
            }, true);

            document.getElementById('name-modal').classList.add('hidden');
        }
    });
}

/**
 * Initialize preferential attention modal handlers
 */
export function initPreferentialModal() {
    const prefButtons = document.querySelectorAll('.preferential-btn');
    const modal = document.getElementById('preferential-modal');
    const confirmButton = document.getElementById('confirm-preferential');
    const cancelButton = document.getElementById('cancel-preferential');
    const isPreferentialInput = document.getElementById('isPreferential');

    prefButtons.forEach(button => {
        button.addEventListener('click', () => {
            const value = button.dataset.value;

            if (value === 'true') {
                // Show confirmation modal
                modal.classList.remove('hidden');
            } else {
                // Directly set to false
                isPreferentialInput.value = 'false';
                updatePreferentialButtonStyles(prefButtons, 'false');
            }
        });
    });

    confirmButton.addEventListener('click', () => {
        isPreferentialInput.value = 'true';
        updatePreferentialButtonStyles(prefButtons, 'true');
        modal.classList.add('hidden');
    });

    cancelButton.addEventListener('click', () => {
        isPreferentialInput.value = 'false';
        updatePreferentialButtonStyles(prefButtons, 'false');
        modal.classList.add('hidden');
    });
}

/**
 * Update preferential button styles
 *
 * @param {NodeList} buttons - Button elements
 * @param {string} selectedValue - 'true' or 'false'
 */
function updatePreferentialButtonStyles(buttons, selectedValue) {
    buttons.forEach(btn => {
        btn.classList.remove('bg-green-500', 'bg-[var(--color-primary)]', 'text-white');

        if (btn.dataset.value === selectedValue) {
            if (selectedValue === 'true') {
                btn.classList.add('bg-green-500', 'text-white');
            } else {
                btn.classList.add('bg-[var(--color-primary)]', 'text-white');
            }
        }
    });
}
